import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import useApiMethods from '../../lib/useApiMethods';
import { CUSTOMERSETCATEGORY } from '../../constants/api';
import { ContainerCard } from '../../components/ui/cards';
import { cn } from '../../utils/tailwindUtils';
import { Search,Plus,Eye,Edit,Trash } from 'lucide-react';
import {Input,Textarea} from "../../components/ui/input";
import { Button } from '../../components/ui/button';
import { useSidebar } from '../../components/ui/sidebar';
import { DialogModal } from '../../components/ui/dialogModal';
import ToastMsg from '../../components/common/ToastMsg';
import { CATEGORYLIST } from '../../constants/api';
import { ConfirmPopupModal } from '../../components/ui/dialogModal';

const FunnelCategory = () => {

    const login_role = sessionStorage.getItem("login_role");
    const {fetch,create,update,remove} = useApiMethods();
    const navigate =useNavigate();

    const [categoryCounts, setCategoryCounts] = useState([])
    const [warningConfirm,setWarningConfirm] = useState(false)
    const [warningMessage,setWarningMessage] = useState('')
    const [categoryId,setCategoryId] = useState(null)
    const [isDeleteConfirmOpen,setIsDeleteConfirmOpen] = useState(false)
    const [showCategoryDialogModal,setShowCategoryDialogModal] =useState(false)
    const [searchCategory,setSearchCategory] = useState('')
    const [editMode,setEditMode] = useState(false)
    const [loading,setLoading] = useState(false)
    const [categoryPayloadValue,setCategoryPayloadValue]=useState({
        category_name:'',
        category_description:'',
        is_active:false,
    })
    const [serverSide,setServerSide]=useState(false)

    const [funnelCategoryList,setFunnelCategoryList] = useState([]);

    const filteredCategory = funnelCategoryList?.filter(category=>category.category_name.toLowerCase().includes(searchCategory.trim().toLowerCase()));

    // const funnelCategoryCount =async()=>{
    //     try{
    //     const response = await fetch(CUSTOMERSETCATEGORY)
    //     setCategoryCounts(response.data);
    //     }
    //     catch(error){
    //         ToastMsg('error',"error");
    //     }
    // }

    const handleFunnelCategoryDetails = (category)=>{
        navigate('/funnelcategory/funnelcategorydetails',{state:{category}})
    }

    const onCloseCategoryDialogModal=()=>{
        setShowCategoryDialogModal(false);
        setCategoryPayloadValue({
            category_name:"",
            category_description:'',
            is_active:false,
        })
        setCategoryId(null)
    }

    //get category
    const handleCategoryPayloadValueForGet = async ()=>{
        try{
            const response=await fetch(CATEGORYLIST );
            setFunnelCategoryList(response.data);
        }
        catch(error){
            ToastMsg("error",error.message);
        }
    }

    //update category
    const handleCategoryPayloadValueForUpdate = async ()=>{
        try{
            let payload={
                category_id:categoryId,
                category_name:categoryPayloadValue.category_name,
                category_description:categoryPayloadValue.category_description,
                is_active:categoryPayloadValue.is_active
            }
            const response=await update(CATEGORYLIST,payload);

            if(response.status==="success"){
                setCategoryPayloadValue({
                    category_name:"",
                    category_description:'',
                    is_active:false,
                })
                setCategoryId(null)
                ToastMsg("success",response.message);
                setServerSide(prv=>!prv)
                setShowCategoryDialogModal(false)
                
            }
            else{
                ToastMsg("error",response.message);
            }
        }
        catch(error){
            ToastMsg("error",error.message);
        }
    }

    //add category
    const handleCategoryPayloadValueForAdd = async ()=>{
        try{
            let payload={
                category_name:categoryPayloadValue.category_name,
                category_description:categoryPayloadValue.category_description,
                is_active:categoryPayloadValue.is_active
            }
            
            const response=await create(CATEGORYLIST,payload);

            if(response.status==="success"){
                setCategoryPayloadValue({
                    category_name:"",
                    category_description:'',
                    is_active:false,
                })
                setServerSide(prv=>!prv)
                ToastMsg("success",response.message);
                setShowCategoryDialogModal(false)
            }
            else{
                ToastMsg("error",response.message);
            }
        }
        catch(error){
            ToastMsg("error",error.message);
        }
    }

    //delete category
    const handleCategoryPayloadValueForDelete = async ()=>{
        try{
            const response=await remove(CATEGORYLIST,{category_id:categoryId});

            if(response.status==="success"){
                setServerSide(prv=>!prv)
                setIsDeleteConfirmOpen(false)
                setCategoryId(null)
                ToastMsg("success",response.message)
            }
            else if(response.status==="warning"){
                setWarningConfirm(true)
                setIsDeleteConfirmOpen(false)
                setWarningMessage(response.message)
            }
            else{
                ToastMsg("error",response.message);
            }
        }
        catch(error){
            ToastMsg("error",error.message);
        }
    }

    //delete warning category
    const handleWarningConfirm=async()=>{
        try{
            const response=await remove(CATEGORYLIST,{category_id:categoryId,confirm:warningConfirm});

            if(response.status==="success"){
                setServerSide(prv=>!prv)
                setCategoryId(null)
                ToastMsg("success",response.message)
                setWarningConfirm(false)
                setWarningConfirm('')
            }
            else{
                ToastMsg("error",response.message);
            }
        }
        catch(error){
            ToastMsg("error",error.message);
        }
    }

    const addNewCategoryButton=()=>{
        setShowCategoryDialogModal(true)
        setEditMode(false)
    }

    const editCategoryButton=(category)=>{
        setShowCategoryDialogModal(true)
        setCategoryId(category.id)
        setEditMode(true)
        setCategoryPayloadValue({
            category_name:category.category_name,
            category_description:category.category_description,
            is_active:category.is_active,
        })
    }

    const deleteCategoryButton=(id)=>{
        setCategoryId(id)
        setIsDeleteConfirmOpen(true)
    }

    useEffect(()=>{
        handleCategoryPayloadValueForGet()
        // funnelCategoryCount();
        // handleCategoryPayloadValueForGet();
    },[serverSide])

  return (
    <ContainerCard>
        <div className='p-2'>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-foreground">
                        Funnel
                    </h1>
                    <p className="text-sm text-muted-foreground mt-1">
                        Access all your funnel in one place
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">

                    {/* Search Bar */}
                    <div className="relative flex-1 max-w-full sm:max-w-xs">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                        <Input
                            type="search"
                            placeholder="Search Funnel..."
                            value={searchCategory}
                            onChange={(e) => setSearchCategory(e.target.value)}
                            className={cn(
                                "pl-9 pr-3 h-10 w-full rounded-lg",
                                "bg-background border border-input",
                                "placeholder:text-muted-foreground",
                                "transition-colors duration-200"
                            )}
                        />
                    </div>
                    {login_role === 'super_admin'&&
                    <Button
                        size="lg"
                        className={cn(
                            "bg-primary hover:bg-sidebar-primary",
                            "dark:bg-sidebar-primary dark:hover:bg-sidebar-primary/90",
                            "text-white transition-colors duration-200",
                            "shadow-sm hover:shadow-md",
                            "whitespace-nowrap"
                        )}
                        onClick={addNewCategoryButton}
                        aria-label={`Add new Funnel`}
                    >
                        <Plus className="w-4 h-4 mr-2" />
                        Add new Funnel
                    </Button>}
                </div>
            </div>

            {/* Categories Count */}
            <div className="mb-4">
                <p className="text-sm text-muted-foreground">
                    {filteredCategory?.length||0} funnel found
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {filteredCategory?.sort((a,b)=>(b.is_active-a.is_active)).map((category,idx)=>{
                    return (
                        <div
                            key={idx}
                            className={cn(
                                "group flex flex-col gap-3 p-5 rounded-xl border",
                                "bg-card text-card-foreground border-border",
                                "hover:shadow-md hover:border-primary dark:hover:border-primary",
                                "cursor-pointer transition-all duration-200",
                                "hover:scale-[1.02] transform-gpu"
                            )}
                        >
                            <div className='flex justify-between'>
                                <div className="flex items-center gap-3">
                                    <h3 className="text-sm font-semibold text-gray-700 group-hover:text-primary dark:group-hover:text-sidebar-primary transition-colors duration-200">
                                        {category.category_name}
                                    </h3>
                                </div>
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {category?.customer_count||0}
                                </p>
                            </div>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                {category.category_description}
                            </p>
                            <div className='mt-auto flex justify-between gap-2 pt-4 border-t border-gray-100 dark:border-gray-700'>
                                <div>
                                    <span
                                        className={cn(
                                            "px-2 py-1 text-xs font-medium rounded-full capitalize",
                                            category.is_active
                                                ? "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300"
                                                : "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300"
                                        )}
                                    >
                                        {category.is_active ? "Active" : "Inactive"}
                                    </span>
                                </div>

                                <div>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className="text-sidebar-primary hover:bg-blue-50 dark:hover:bg-gray-700"
                                        onClick={()=>editCategoryButton(category)}
                                    >
                                        <Edit className="h-4 w-4" />
                                    </Button>

                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className="text-sidebar-primary hover:bg-blue-50 dark:hover:bg-gray-700"
                                        onClick={() => handleFunnelCategoryDetails({category_id:category.id,category_name:category.category_name})}
                                    >
                                        <Eye className="h-4 w-4" />
                                    </Button>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className="text-red-500 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/30"
                                        onClick={() => deleteCategoryButton(category.id)}
                                    >
                                        <Trash className="h-4 w-4" />
                                    </Button>
                                </div>    
                            </div>    
                        </div>
                    )
                })}
            </div>

        </div>

        {/*Add or Edit Category */}
        <DialogModal
            open={showCategoryDialogModal}
            onClose={onCloseCategoryDialogModal}
            onSave={editMode?handleCategoryPayloadValueForUpdate:handleCategoryPayloadValueForAdd}
            title={editMode?"Update Funnel":"Add Funnel"}
            closeLabel="Cancel"
            saveLabel={editMode?"Edit":"Save"}
            loading={loading}
            width="500px"
            editMode={editMode}
        >
            <form className="space-y-4  overflow-auto p-2">
                {/* Category Name */}
                <div className="space-y-2">
                    <label
                        htmlFor="categoryName"
                        className="text-xs font-medium text-gray-700 dark:text-gray-300 flex items-center gap-1"
                    >
                        Funnel Name <span className="text-red-500">*</span>
                    </label>
                    <Input
                        id="categoryName"
                        value={categoryPayloadValue.category_name}
                        onChange={(e) =>
                            setCategoryPayloadValue({...categoryPayloadValue,category_name:e.target.value})
                        }
                        placeholder="Enter funnel name"
                        required
                        disabled={loading}
                        className={cn(
                            "w-full rounded-lg transition-colors duration-200",
                            "border-gray-300 dark:border-gray-600",
                            "bg-white dark:bg-gray-700 text-gray-900 dark:text-white",
                            "focus:border-sidebar-primary focus:ring-2 focus:ring-sidebar-primary/20",
                            "disabled:bg-gray-100 disabled:text-gray-500 dark:disabled:bg-gray-800 dark:disabled:text-gray-400"
                        )}
                    />
                </div>
                {/* Category Description - Full Width */}
                <div className="space-y-2">
                    <label
                        htmlFor="category_description"
                        className="text-xs font-medium text-gray-700 dark:text-gray-300"
                    >
                        Funnel Description
                    </label>
                    <Textarea
                        id="category_description"
                        value={categoryPayloadValue.category_description}
                        onChange={(e) =>
                            setCategoryPayloadValue({...categoryPayloadValue,category_description:e.target.value})
                        }
                        placeholder="Enter Funnel description"
                        rows={3}
                        showCharCount={true}
                        maxLength={250}
                        disabled={loading}
                        className={cn(
                            "w-full rounded-md transition-colors duration-200",
                            "border-gray-300 dark:border-gray-600",
                            "bg-white dark:bg-gray-700 text-gray-900 dark:text-white",
                            "focus:border-sidebar-primary focus:ring-2 focus:ring-sidebar-primary/20",
                            "disabled:bg-gray-100 disabled:text-gray-500 dark:disabled:bg-gray-800 dark:disabled:text-gray-400"
                        )}
                    />
                </div>
                 {/* Active Status - Full Width */}
                <div className="flex items-center justify-between p-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                    <label
                        htmlFor="is_active"
                        className="text-xs font-medium text-gray-700 dark:text-gray-300"
                    >
                        Active Status
                    </label>
                    <div className="flex items-center gap-3">
                        <span className={cn(
                            "text-xs font-medium",
                            editMode?categoryPayloadValue.is_active
                                ? "text-green-600 dark:text-green-400"
                                : "text-gray-500 dark:text-gray-400":"text-green-600 dark:text-green-400"
                        )}>
                            {editMode?categoryPayloadValue.is_active ? "Active" : "Inactive":true}
                        </span>
                        <button
                            type="button"
                            onClick={() => setCategoryPayloadValue({ ...categoryPayloadValue, is_active:editMode?!categoryPayloadValue.is_active:true})}
                            className={cn(
                                "relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200",
                                editMode?categoryPayloadValue.is_active ? "bg-sidebar-primary" : "bg-gray-300 dark:bg-gray-600":"bg-sidebar-primary",
                                loading ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                            )}
                            disabled={loading}
                        >
                            <span
                                className={cn(
                                    "inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform duration-200",
                                    editMode?categoryPayloadValue.is_active ? "translate-x-4" : "translate-x-1":"translate-x-4" 
                                )}
                            />
                        </button>
                    </div>
                </div>    
            </form>
        </DialogModal> 
         {/* Delete Confirmation Modal */}
        <ConfirmPopupModal
            open={isDeleteConfirmOpen}
            onClose={() => {
                setIsDeleteConfirmOpen(false);
                setCategoryId(null);
            }}
            onConfirm={handleCategoryPayloadValueForDelete}
            title="Delete Funnel"
            description="Are you sure you want to delete this Funnel? This action cannot be undone."
            type="warning"
            confirmLabel="Delete"
            destructive={true}
            loading={loading}
        />

        {/* Delete Warning Confirmation Modal */}
        <ConfirmPopupModal
            open={warningConfirm}
            onClose={() => {
                setIsDeleteConfirmOpen(false);
                setWarningConfirm(false);
                setCategoryId(null);
            }}
            onConfirm={handleWarningConfirm}
            title="Warning"
            description={warningMessage}
            type="warning"
            confirmLabel="Confirm"
            destructive={true}
            loading={loading}
        />
        

    </ContainerCard>
  )
}

export default FunnelCategory